<template>
  <div class="video-dot-list" v-if="shouldRenderList || summaryText">
    <div class="header" v-if="shouldRenderList">
      <div class="title">课程知识点</div>
    </div>
    <div class="dot-list" v-if="shouldRenderList">
      <div
        v-for="(dot, dotIndex) in knowledges"
        :key="dot && dot.knowledgeId"
        class="dot-item"
        v-track="{ functionName: `${dot.knowledge}` }"
        :class="isCurrentDot(dotIndex) ? 'cur':''"
        @click.stop="handleJump(dot)"
      >
        <div class="dot-item-cont">
          <div class="dot-icon">
            <img src="@/assets/images/course/dot-icon-active.png" alt="" v-if="isCurrentDot(dotIndex)">
            <img src="@/assets/images/course/dot-icon.png" alt="" v-else>
          </div>
          <div class="dot-title">
            <span class="name">{{ dot && dot.knowledge }}</span>
            <span class="time">({{ dot.knowledgeStartTime || dot.startTime }} - {{ dot.knowledgeEndTime || dot.endTime }})</span>
          </div>
        </div>
        <div class="dot-line"></div>
      </div>
    </div>
    <!--课程总结-->
    <div class="header" v-if="summaryText">
      <div class="title">课程总结</div>
    </div>
    <!--课程总结-内容-->
    <div class="dot-list" v-if="summaryText">
      <div class="dot-item">
        <div class="dot-item-cont">
          <div class="dot-title summary-title">
            <span class="name summary-name">{{ summaryText }}</span>
          </div>
        </div>
      </div>
    </div>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="goDetail" :dataProps="dataProps"></dialogUnlock>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import {isScorm} from '../../../api/scorm'

export default {
  components: {
    dialogUnlock
  },
  props: ['curTabKey', 'currentData'],
  data() {
    return {
      cachedFirstHitIndex: null,
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  computed: {
    shouldRenderList() {
      const {courseSection, knowledgeList} = this.currentData
      return this.curTabKey === '1' ? (courseSection &&
        courseSection.knowledges &&
        courseSection.knowledges.length > 0) : (knowledgeList &&
        knowledgeList.length > 0)
    },
    // 课程总结
    summaryText() {
      const data = this.currentData || {}
      if (Number(data.type) !== 2) return ''
      const section = data.courseSection || {}
      const text = data.summaryText || section.summaryText || ''
      return String(text).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()
    },
    knowledges() {
      if (this.shouldRenderList) {
        const {courseSection, knowledgeList} = this.currentData
        return this.curTabKey === '1' ? courseSection && courseSection.knowledges.slice(0, 3) : knowledgeList
      }
      return []
    }
  },
  methods: {
    handleJump(item) {
      const { isUnlock, myUnlock, type, baseId, unlockCost } = this.currentData
      if (this.curTabKey === '1') {
        if (`${isUnlock}` === '1' && !myUnlock && `${type}` === '2') {
          this.dataProps.baseId = baseId
          this.dataProps.unlockCost = unlockCost
          this.$refs.dialogUnlock.dailogShow = true
          return
        }
      }
      this.goDetail(item)
    },
    async goDetail(item) {
      const entrance = this.curTabKey === '2' ? '52' : '5'
      window.sessionStorage.setItem('entrance', entrance)
      localStorage.setItem('functionUrl', `courseId=${this.currentData.baseId}&sectionId=${this.curTabKey === '1' ? this.currentData.courseSection.sectionId : this.currentData.sectionId}&knowledgeId=${this.curTabKey === '1' ? item.knowledgeId : item.id}`)
      const query = {
        courseId: this.currentData.baseId,
        sectionId: this.curTabKey === '1' ? this.currentData.courseSection.sectionId : this.currentData.sectionId,
        knowledgeDuration: item.knowledgeDuration,
        entrance: entrance,
        channel: entrance,
        fromPage: 'search'
      }
      const isscorm = await isScorm(this.currentData.baseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    },
    isCurrentDot(dotIndex) {
      if (this.knowledges.length === 0) return false
      const firstHitIndex = this.knowledges.findIndex(item => item.isHit)
      return firstHitIndex !== -1 ? dotIndex === firstHitIndex : dotIndex === 0
    },
  }
}
</script>

<style scoped lang="less">
.video-dot-list {
  margin-top: 5px;

  .header {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    height: 30px;

    .title {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #22323E;
    }
  }

  .dot-list {
    box-sizing: border-box;
    position: relative;

    .dot-item {
      position: relative;
      margin-bottom: 10px;
      cursor: pointer;

      .dot-item-cont {
        display: flex;
        align-items: flex-start;

        .dot-icon {
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6px;

          img {
            width: 6px;
          }
        }

        .dot-title {
          display: flex;
          align-items: flex-start;
          flex: 1;

          .time {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 12px;
            color: #B1B1B1;
            width: 130px;
            line-height: 22px;
          }

          .name {
            margin-right: 5px;
            flex: 1;
            width: 0;
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
            display: -webkit-box; //特别显示模式
            -webkit-line-clamp: 2; //行数
            line-clamp: 2;
            -webkit-box-orient: vertical; //盒子中内容竖直排列
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #5F5F5F;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      &:last-child {
        height: auto;
        margin-bottom: 0;

        .dot-line {
          display: none;
        }
      }

      .dot-line {
        position: absolute;
        top: 14px;
        left: 2px;
        width: 2px;
        height: 100%;
        border-radius: 10px;
        background: url("~@/assets/images/course/dot-line.png") no-repeat center center / 100% 100%;
      }

      .summary-title {
        min-width: 0;
      }

      .summary-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
      }

      &.cur {
        .dot-item-cont {
          .dot-title {
            .time {
              color: #EB1700;
              font-weight: 600;
            }

            .name {
              color: #EB1700;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/pageSearchDotList.vue